import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';

export default defineSection({
    head: sectionHead({title: 'Alerts'}),
    // the section's stylesheet used to come in through its entry point; it belongs
    // to the section's chunk, not to the bundle every page loads
    setup: () => import(/* webpackChunkName: "alerts" */ './tasks.scss'),
    routes: [
        {
            path: '/notifications/',
            component: () => import(/* webpackChunkName: "alerts" */ './RequestsListPage'),
            name: 'RequestsListPage',
        },
    ]
});
